import { createFileRoute } from '@tanstack/react-router';
import { AlertsCenterPage } from '../../features/B5/alerts-center/alerts-center-page';
import { parseInboxSearch, toUrlSearch, type InboxSearch } from '../../features/B5/alerts-center/inbox-search';

/** #/alerts-center[?view=&scope=&client=&sev=&fam=&status=&sent=&from=&to=&month=] — the staff alerts center (W2-6-9, D-126). */
export const Route = createFileRoute('/_app/alerts-center')({
  // the router keeps the URL form (only what differs from the defaults, csv lists) so the address stays short and readable
  validateSearch: (raw: Record<string, unknown>): Record<string, string> => toUrlSearch(parseInboxSearch(raw)),
  component: AlertsCenterRoute,
});

function AlertsCenterRoute() {
  const raw = Route.useSearch();
  const search = parseInboxSearch(raw);
  const navigate = Route.useNavigate();
  const setSearch = (patch: Partial<InboxSearch>) => void navigate({ search: (prev) => toUrlSearch({ ...parseInboxSearch(prev), ...patch }), replace: true });
  return <AlertsCenterPage search={search} setSearch={setSearch} />;
}
